module.exports = __webpack_public_path__ + "img/18-items.b97d9adb.jpg";